import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IBaseWidgetConfig } from '../base/widget-list';

/**
 * Sluzba pre ukladanie dat pre widgety.
 * Umoznuje komunikaciu medzi widgetmi a ich nastaveniami.
 */

@Injectable()
export class WidgetDataService<T extends IBaseWidgetConfig> {

  private _defaultOptions?: T;

  private _options: BehaviorSubject<T | undefined> = new BehaviorSubject<T | undefined>(undefined); 
  public options$: Observable<T | undefined> = this._options.asObservable();

  private _onResize: BehaviorSubject<{width: number, height: number} | null> = new BehaviorSubject<{width: number, height: number} | null>(null);
  public onResize$: Observable<{width: number, height: number} | null> = this._onResize.asObservable();

  constructor() { }

  // manage options for widget
  public setOptions(options?: T): void {
    if (!this._defaultOptions) {
      this._defaultOptions = options;
    }
    this._options.next(options);
  }

  public getOptions(): T | undefined {
    return this._options.value;
  }

  public parentWidgetResize(width: number, height: number): void {
    this._onResize.next({width, height});
  }
}
